import './bml-news-feed-banner.scss';
const TEMPLATE = `
<section class="main-banner-feed fade-up">
    <div class="feed-circles-wrapper" data-animate-circles>
        <div class="feed-circle feed-circle-extra-large"></div>
        <div class="feed-circle feed-circle-large"></div>
        <div class="feed-circle feed-circle-medium"></div>
    </div>
    <div class="container-fluid">
        <h1 data-animate-child>НОВИНИ ТА ПОДІЇ</h1>
        <div class="row">
            <div class="col-lg-6"></div>
            <div class="col-lg-6">
                <p class="paragraph-news-feed-banner" data-animate-child data-delay="200">Слідкуйте за актуальними подіями, професійними досягненнями та розвитком Bogomolets Medical Laboratories. У цьому розділі ми ділимося новинами лабораторії, впровадженням нових діагностичних можливостей, участю у професійних заходах, експертними матеріалами та важливими подіями у сфері лабораторної медицини.</p>
            </div>
        </div>
    </div>
</section>
`;

class BmlNewsFeedBanner extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-news-feed-banner', BmlNewsFeedBanner);
